module.exports = __webpack_public_path__ + "static/media/pic6@2x.d84f2a5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/pic6@2x.png
// module id = 1418
// module chunks = 0